const releaseDateFormatter = new Intl.DateTimeFormat(undefined, {
  month: "short",
  day: "numeric",
  year: "numeric",
  // The value is a calendar date built at UTC midnight (see below), so format it
  // in UTC too — otherwise UTC-negative timezones render the previous day (#370).
  timeZone: "UTC",
});

export function formatReleaseDate(value?: string | null): string | null {
  if (!value) {
    return null;
  }
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value.trim());
  if (!match) {
    return null;
  }
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (!year || !month || !day) {
    return null;
  }
  return releaseDateFormatter.format(new Date(Date.UTC(year, month - 1, day)));
}
